import { ActionFetch } from '@/store/actionTypes'
import { API } from '@/store/apiPath'
import { AxiosRequest } from '@/store/axiosHelper'
import { MutationStore, MutationView } from '@/store/mutationTypes'

const request = {
  actions: {
    [ActionFetch.CAMPAIGNS.LIST]: ({ commit }, $params = {}) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      return AxiosRequest(API.campaigns.list($params))
        .then(($res) => {
          const data = $res.data
          if (data.success && data.data) {
            commit(MutationStore.CAMPAIGNS.LIST, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.CAMPAIGNS.DETAIL]: ({ commit }, $params = {}) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      return AxiosRequest(API.campaigns.getInfo($params.id))
        .then(($res) => {
          const data = $res.data
          if (data.success && data.data) {
            commit(MutationStore.CAMPAIGNS.DETAIL, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.CAMPAIGNS.CREATE]: ({ commit, rootState }, $params = {}) => {
      commit(MutationView.SET_LOADING_SCREEN, true)
      let user = rootState.cmsUser

      if (!user) {
        user = JSON.parse(localStorage.getItem('cmsUser'))
      }

      $params.createdBy = user.id
      $params.updatedBy = user.id

      return AxiosRequest(API.campaigns.create(), $params, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.CAMPAIGNS.CREATE, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          if (typeof error.response.data.message === 'string') {
            commit(MutationView.SHOW_MODAL_ALERT, error.response.data.message)
          } else {
            commit(MutationView.SHOW_MODAL_ALERT, error.message)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.CAMPAIGNS.UPDATE]: ({ commit, rootState }, $params = {}) => {
      commit(MutationView.SET_LOADING_SCREEN, true)
      let user = rootState.cmsUser

      if (!user) {
        user = JSON.parse(localStorage.getItem('cmsUser'))
      }

      $params.updatedBy = user.id

      return AxiosRequest(API.campaigns.update($params.id), $params, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.CAMPAIGNS.UPDATE, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          if (typeof error.response.message === 'string') {
            commit(MutationView.SHOW_MODAL_ALERT, error.response.message)
          } else {
            commit(MutationView.SHOW_MODAL_ALERT, error.message)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.CAMPAIGNS.UPDATE_PUBLISH]: (
      { commit, rootState },
      $params = {},
    ) => {
      commit(MutationView.SET_LOADING_SCREEN, true)
      let user = rootState.cmsUser

      if (!user) {
        user = JSON.parse(localStorage.getItem('cmsUser'))
      }

      $params.updatedBy = user.id

      return AxiosRequest(
        API.campaigns.updatePublish($params.id),
        $params,
        user.token,
      )
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.CAMPAIGNS.UPDATE_PUBLISH, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.CAMPAIGNS.UPDATESORT]: ({ commit, rootState }, $params) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      let user = rootState.cmsUser

      if (!user) {
        user = JSON.parse(localStorage.getItem('cmsUser'))
      }

      $params.updatedBy = user.id

      return AxiosRequest(API.campaigns.updateSort(), $params, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.CAMPAIGNS.UPDATESORT, data.data)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)

          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.CAMPAIGNS.DELETE]: ({ commit, rootState }, $id) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      const user =
        rootState.cmsUser || JSON.parse(localStorage.getItem('cmsUser'))

      return AxiosRequest(API.campaigns.delete($id), {}, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.CAMPAIGNS.DELETE, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },
  },
}

export default request
